import { debug } from '../utils/debug';

declare const API_URL: string;
declare const CDN_URL: string;
declare const FEATURES_API_URL: string | undefined;
declare const AUDIENCES_API_URL: string | undefined;
declare const ANALYTICS_API_URL: string | undefined;

debug({
  API_URL,
  CDN_URL,
  FEATURES_API_URL,
  AUDIENCES_API_URL,
  ANALYTICS_API_URL,
});

export const AUDIENCES_URL = `${AUDIENCES_API_URL || API_URL}/audiences`;
export const FEATURES_URL = `${FEATURES_API_URL || API_URL}/features`;
export const ANALYTICS_URL = `${ANALYTICS_API_URL || API_URL}/analytics`;
export const ANALYTICS_BID_URL = `${
  ANALYTICS_API_URL || API_URL
}/analytics/bids`;
export const ANALYTICS_ERROR_URL = `${
  ANALYTICS_API_URL || API_URL
}/analytics/error`;
